import { Box, Img, Paper, Stack, Typography, colorsPalette, styled, useUiEvent } from '@lingoda/ui';
import { useDispatch } from '@lingoda/hooks';
import { DialogComponent, showDialog } from '@lingoda/dialogs';
import { actionClick } from '@lingoda/analytics';
import { trans } from '@lingoda/i18n';
import { paperGradient, recapTrackedEvents } from '../constants';
import year2023Svg from '../assets/2023.svg';

export const RecapAchievementsBoardItem = () => {
    const dispatch = useDispatch();
    const addEvent = useUiEvent();

    const handleClick = () => {
        void addEvent(actionClick(recapTrackedEvents.click.LaunchWrapUp));
        dispatch(showDialog(DialogComponent.YearlyRecapDialog));
    };

    return (
        <BoardItemTile onClick={handleClick}>
            <Box flex="1 1 auto" display="flex" alignItems="center">
                <Img width="160px" src={year2023Svg} />
            </Box>
            <Stack spacing={1}>
                <Typography variant="subtitle1">
                    {trans('your-wrap-up', {}, 'student-yearly-recap')}
                </Typography>
                <Typography variant="body2" htmlColor={colorsPalette.blackAlpha[70]}>
                    {trans('unwrap-highlights', {}, 'student-yearly-recap')}
                </Typography>
            </Stack>
        </BoardItemTile>
    );
};

const BoardItemTile = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ theme }) => ({
    padding: theme.spacing(3),
    textAlign: 'center',
    height: '100%',
    minHeight: 216,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: paperGradient,
    cursor: 'pointer',
    ':hover': {
        boxShadow: theme.shadows[4],
    },
}));
